/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  AbstractSnapshotFormComponent,
  formSchemaBuilderByEntityConfig,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getFormStateSnapshotValue,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import {
  CS_MASTER_INFO_ENTITY_CONFIG,
  CSMasterInfoDetails,
} from '../../../resources/cs-master.model';

@Component({
  standalone: false,
  selector: 'gh-cs-master-details-top-form',
  templateUrl: 'cs-master-details-top-form.component.html',
  styleUrls: ['./cs-master-details-top-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CSMasterDetailsTopFormComponent extends AbstractSnapshotFormComponent<CSMasterInfoDetails> {
  constructor(private formStateBuilder: FormStateBuilder) {
    super();
  }

  protected buildForm(snapshot: FormStateSnapshot<CSMasterInfoDetails>): FormState<CSMasterInfoDetails> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        ...formSchemaBuilderByEntityConfig(getFormStateSnapshotValue(snapshot), CS_MASTER_INFO_ENTITY_CONFIG),
      },
    });
  }
}
